import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomStepBadge from '../../../components/OnboardingComponents/CustomStepBadge';
import CustomButton from '../../../components/OnboardingComponents/CustomButton';
import { ICONS } from '../../../components/OnboardingComponents/icon';

const Step5Success = ({ onComplete, onBack }) => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate("/dashboard", { replace: true })
  }

  return (
  <div className="amok-onboarding-step">
    <div className="amok-onboarding-step__header">
      <CustomStepBadge tone="accent">Done</CustomStepBadge>
    </div>

    <h2 className="amok-onboarding-step__title">Profile complete</h2>
    <p className="amok-onboarding-step__subtitle">
      You&rsquo;re all set. Let&rsquo;s get started with Amok Earth.
    </p>

    <div className="amok-onboarding-step__footer">
      <CustomButton variant="secondary" size="md" iconSrc={ICONS.arrowLeft} onClick={onBack}>
        Back
      </CustomButton>
      <CustomButton variant="primary" size="md" trailingIconSrc={ICONS.arrowRight} onClick={handleGoToDashboard}>
        Go to Dashboard
      </CustomButton>
    </div>
  </div>
  );
};

export default Step5Success;
